import { useEditorModel } from '@/store/models/editor-model';

export interface IEditorFeature {
    leave?: Function;
    enter?: Function;
}

const editorFeature: Map<string, IEditorFeature> = new Map();

export const useFeatureHelper = () => {
    const setFeature = useEditorModel((actions) => actions.setFeature);
    const getFeature = useEditorModel((actions) => actions.getFeature);

    return {
        /**
         * 获取当前功能名称
         * @returns
         */
        getCurFeature() {
            return getFeature();
        },
        /**
         * 使用某功能
         *
         * @param type - 类型
         * @param params - 参数
         */
        async use(type: string, params?: any) {
            await editorFeature.get(getFeature())?.leave?.();
            await editorFeature.get(type)?.enter?.(params);
            setFeature(type);
        },
        /**
         * 注册功能
         *
         * @param type - 类型
         * @param feature - 特性
         */
        register(type: string, feature: IEditorFeature) {
            editorFeature.set(type, feature);
        },
    };
};
